import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';

import S12nToCourseraPlusIneligibleModal from 'bundles/coursera-plus/components/s12nToCourseraPlusUpgrade/S12nToCourseraPlusIneligibleModal';
import S12nToCourseraPlusStartModal from 'bundles/coursera-plus/components/s12nToCourseraPlusUpgrade/S12nToCourseraPlusStartModal';
import S12nToCourseraPlusUpgradeModal from 'bundles/coursera-plus/components/s12nToCourseraPlusUpgrade/S12nToCourseraPlusUpgradeModal';
import {
  useIsFromS12nToPlusUpgradeEmail,
  useS12nToPlusUpgradeData,
} from 'bundles/coursera-plus/utils/s12nToCourseraPlusUpgradeUtils';

const MODAL_STEPS = {
  START: 'START',
  UPGRADE: 'UPGRADE',
  INELIGIBLE: 'INELIGIBLE',
} as const;

const S12nToCourseraPlusUpgradeContainer = () => {
  const [currentModal, setCurrentModal] = useState<keyof typeof MODAL_STEPS | undefined>();

  const { isFromS12nToPlusMonthlyUpgradeEmail, isFromS12nToPlusAnnualUpgradeEmail } = useIsFromS12nToPlusUpgradeEmail();
  const isFromUpgradeEmail = isFromS12nToPlusMonthlyUpgradeEmail || isFromS12nToPlusAnnualUpgradeEmail;
  const { isEligibleForS12nToPlusUpgrade, subscriptions, courseraPlusPrice } = useS12nToPlusUpgradeData({
    isCourseraPlusAnnualUpgrade: isFromS12nToPlusAnnualUpgradeEmail,
    skip: !isFromUpgradeEmail,
  });

  useEffect(() => {
    if (!isFromUpgradeEmail) {
      return;
    }

    if (isEligibleForS12nToPlusUpgrade) {
      setCurrentModal(MODAL_STEPS.START);
    } else if (!isEligibleForS12nToPlusUpgrade) {
      setCurrentModal(MODAL_STEPS.INELIGIBLE);
    }
  }, [isFromUpgradeEmail, isEligibleForS12nToPlusUpgrade]);

  const hideModal = useCallback<() => void>(() => setCurrentModal(undefined), []);
  const openUpgradeModal = useCallback<() => void>(() => setCurrentModal(MODAL_STEPS.UPGRADE), []);
  const subscription = subscriptions?.[0];

  return (
    <>
      {isEligibleForS12nToPlusUpgrade && subscription && (
        <S12nToCourseraPlusStartModal
          isCourseraPlusAnnualUpgrade={isFromS12nToPlusAnnualUpgradeEmail}
          isOpen={currentModal === MODAL_STEPS.START}
          onClose={hideModal}
          openUpgradeModal={openUpgradeModal}
          subscription={subscription}
        />
      )}
      {isEligibleForS12nToPlusUpgrade && subscription && courseraPlusPrice && (
        <S12nToCourseraPlusUpgradeModal
          isCourseraPlusAnnualUpgrade={isFromS12nToPlusAnnualUpgradeEmail}
          isOpen={currentModal === MODAL_STEPS.UPGRADE}
          onClose={hideModal}
          subscription={subscription}
          courseraPlusPrice={courseraPlusPrice}
        />
      )}
      <S12nToCourseraPlusIneligibleModal
        isOpen={currentModal === MODAL_STEPS.INELIGIBLE}
        subscriptionCount={subscriptions?.length ?? 0}
        onClose={hideModal}
      />
    </>
  );
};

export default S12nToCourseraPlusUpgradeContainer;
